/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CmpTaskBaseDto } from "./cmp-task-base-dto";

export class DoUiActionDto<CmpTaskBaseDto> {
    uiActionVerb: string = undefined;
    actionReason: string = undefined;
    taskDto: CmpTaskBaseDto;
    payload: any;

    //<custom-body>
    
    //</custom-body>
}
